export default "__VITE_ASSET__BUJ$h$h5__"